module.exports = __webpack_public_path__ + "static/media/img-mygood-thumb.7f9d13a3.png";